import { makeAutoObservable } from 'mobx'
import type { IResponseFullAICallingAgent } from 'entities/AICalling/api/types'
import { AgentKnowledgeBaseStore } from 'pages/chatbot/ui/AgentKnowledgeBase/store/AgentKnowledgeBaseStore'

export class AIKnowledgeBaseStore {
  readonly agentKnowledgeBaseStore: AgentKnowledgeBaseStore
  constructor(
    readonly parent: {
      response?: IResponseFullAICallingAgent | null
    }
  ) {
    if (parent.response) {
      this.setKnowledgeBaseUsage(parent.response.knowledge_base_enabled || false)
      if (parent.response.knowledge_base_documents) {
        this.setKnowledgeBaseDocuments(parent.response.knowledge_base_documents)
      }
    }
    this.agentKnowledgeBaseStore = new AgentKnowledgeBaseStore(
      parent.response?.knowledge_base_all_documents
    )
    makeAutoObservable(this)
  }

  get params() {
    if (!this.knowledgeBaseUsage) {
      return {
        knowledge_base_enabled: false,
        knowledge_base_documents: [],
        knowledge_base_all_documents: true,
      }
    }
    return {
      knowledge_base_enabled: this.knowledgeBaseUsage,
      knowledge_base_documents: this.knowledgeBaseDocuments,
      knowledge_base_all_documents:
        this.agentKnowledgeBaseStore.agentDocumentsStore.params.isSelectAllDocuments,
    }
  }

  private _knowledgeBaseUsage = false
  get knowledgeBaseUsage() {
    return this._knowledgeBaseUsage
  }

  setKnowledgeBaseUsage = (value: typeof this._knowledgeBaseUsage) => {
    this._knowledgeBaseUsage = value
  }

  private _knowledgeBaseDocuments: number[] = []
  get knowledgeBaseDocuments() {
    return this._knowledgeBaseDocuments
  }

  setKnowledgeBaseDocuments = (documents: number[]) => {
    this._knowledgeBaseDocuments = documents
  }

  private _knowledgeBaseDocumentsError = ''
  get knowledgeBaseDocumentsError() {
    return this._knowledgeBaseDocumentsError
  }
  setKnowledgeBaseDocumentsError = (value: string) => {
    this._knowledgeBaseDocumentsError = value
  }
  checkValidate = () => {
    if (!this.params.knowledge_base_enabled) return true
    return this.agentKnowledgeBaseStore.checkValidate()
  }
}
